import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider, initTheme } from './lib/useTheme';
import './index.css';
import './styles/dark-theme.css';

// 첫 페인트 전에 data-theme 스탬프 — 다크모드 FOUC(흰 화면 번쩍임) 방지
initTheme();

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* ThemeProvider 는 라우터 밖 최상단 — 로그인 밖 라우트(/public, /form)에서도 테마 적용 */}
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
